<template>
  <div class="root">
    <div class="title">
      <div class="active">联网模式</div>
      <div @click="$router.push({name:'devicelocal',query:{iccid:imei}})">本地模式</div>
    </div>
    <div class="box-1">
      <div>
        <img src="../assets/images/dianliang_03.png"/>
        <span>电量{{ deviceInfo.battery }}%</span>
      </div>
      <div>
        <img src="../assets/images/lianjie_03.png" />
        <span>设备连接 {{deviceInfo.client_number}}</span>
      </div>
      <div>
        <img src="../assets/images/zaixian_03.png"/>
        <span>{{ deviceInfo.isonline?'在线':'离线' }}</span>
      </div>
    </div>
    <div class="box-2">
      <div class="box-title">设备设置</div>
      <div class="content">
        <div class="input-control">
          <div class="label">WiFi名称：</div>
          <input :placeholder="deviceInfo.ssid" v-model="editSsid.ssid"/>
<!--          <div class="addon">保存</div>-->
        </div>
        <div class="input-control">
          <div class="label">WiFi密码：</div>
          <input :placeholder="deviceInfo.key"  v-model="editSsid.key"/>
          <div class="addon" @click="saveSsid">保存</div>
        </div>
        <div class="input-control">
          <div class="label">设备重启</div>
          <div class="addon" @click="restart">重启</div>
        </div>
        <div class="input-control">
          <div class="label">设备恢复出厂设置</div>
          <div class="addon" @click="reset">重置</div>
        </div>
      </div>
    </div>
    <div class="box-2">
      <div class="box-title">网络切换</div>
      <div class="content flex">
        <div class="net-check" :class="deviceInfo.simIndex==0?'active':''" @click="qieka(0)" v-if="deviceInfo.dianxin && (operator.netType==2 || operator.netType==5 || operator.netType==6 || operator.netType == 0)">
          <img v-if="deviceInfo.simIndex == 0" src="../assets/newimg/dianxin_active.png" />
          <img v-else src="../assets/newimg/dianxin.png" />
          <div>中国电信</div>
          <img src="../assets/newimg/xuanzhong.png" class="tag">
        </div>
        <div class="net-check" :class="deviceInfo.simIndex==1?'active':''"  @click="qieka(1)" v-if="deviceInfo.liantong && (operator.netType==3 || operator.netType==5 || operator.netType==7 || operator.netType == 0)">
          <img v-if="deviceInfo.simIndex == 1" src="../assets/newimg/liantong_active.png" />
          <img v-else src="../assets/newimg/liantong.png"/>
          <div>中国联通</div>
          <img src="../assets/newimg/xuanzhong.png" class="tag">
        </div>
        <div class="net-check" :class="deviceInfo.simIndex==2?'active':''" @click="qieka(2)" v-if="deviceInfo.yidong && (operator.netType==4 || operator.netType==6 || operator.netType==7 || operator.netType == 0)">
          <img v-if="deviceInfo.simIndex == 2" src="../assets/newimg/yidong_active.png" />
          <img v-else src="../assets/newimg/yidong.png" />
          <div>中国移动</div>
          <img src="../assets/newimg/xuanzhong.png" class="tag">
        </div>
        <div v-if="operator.netType == 0 || operator.netType > 4" :class="deviceInfo.simIndex==99?'active':''" class="net-check one" @click="qieka(99)">
          <div>智能选网</div>
          <img src="../assets/newimg/xuanzhong.png" class="tag">
        </div>
      </div>
    </div>
    <div class="box-2">
      <div class="box-title">设备信息</div>
      <div class="content noborder">
        <div class="input-control">
          <div class="label">卡号：</div>
          <div class="text">
           {{deviceInfo.iccid}}
          </div>
        </div>
        <div class="input-control">
          <div class="label">信号强度：</div>
          <div class="text">{{ deviceInfo.rsrp }}dbm 良好</div>
        </div>
        <div class="input-control">
          <div class="label">IMEI码：</div>
          <div class="text">{{ deviceInfo.imei }}</div>
        </div>
        <div class="input-control">
          <div class="label">SN：</div>
          <div class="text">{{ deviceInfo.sn }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "device",
  data() {
    return {
      imei:'',
      deviceInfo:{},
      editSsid:{ssid:'',key:''},
      mode:0,
      operator:{}
    };
  },
  methods: {
    getDeviceInfo(){
      this.$toast.loading({duration:0})
      this.fetchData('/card/deviceInfo', {iccid: this.imei}, (res) => {
        this.$toast().clear()
        this.deviceInfo = res.data
      })
    },
    restart(){
      if(!this.deviceInfo.isonline){
        return this.$toast("请先让设备联网在线");
      }
      this.$toast.loading({message:'发送中'})
      this.fetchData("/card/restartDevice",{iccid:this.imei},res=>{
        this.$toast.clear()
        this.$toast(res.msg)
      })
    },
    reset(){
      if(!this.deviceInfo.isonline){
        return this.$toast("请先让设备联网在线");
      }
      this.$dialog.confirm({
        title: '提示',
        message: '确认将设备恢复到出厂状态？',
      }).then((res)=>{
        this.$toast.loading({message:'发送中'})
          this.fetchData("/card/resetDevice",{iccid:this.imei},res=>{
            this.$toast.clear()
            this.$toast(res.msg)
          })
      }).catch((err)=>{

      })
    },
    saveSsid(){
      if(!this.deviceInfo.isonline){
        return this.$toast("请先让设备联网在线");
      }
      if(!this.editSsid.ssid || !this.editSsid.key){
        return this.$toast("请输入WiFi名称和密码")
      }
      if(this.editSsid.key.length < 8){
        return this.$toast("请输入至少8位密码")
      }
      if(/[^\dA-Za-z]/.test(this.editSsid.key)){
        return this.$toast("密码只支持数字字母组合")
      }
      this.$toast.loading({message:'设置中',forbidClick:true})
      this.fetchData("/card/savessid",{iccid:this.imei,ssid:this.editSsid.ssid,key:this.editSsid.key},res=>{
        this.$toast.clear()
        this.$toast(res.msg)
      })

    },
    qieka(index){
      if(index == this.deviceInfo.simIndex){
        return false;
      }
      if(!this.deviceInfo.isonline){
       // return this.$toast("请先让设备联网在线");
      }
      this.$toast.loading({message:'设置中',forbidClick:true})
      this.fetchData("/card/shuangkaqieka",{iccid:this.imei,simIndex:index},res=>{
        this.$toast.clear()
        this.$toast(res.msg)
        if(res.code){
          this.deviceInfo.simIndex = index
        }
      })
    }
  },
  created() {
    this.imei = this.$route.query.iccid
    this.getDeviceInfo()
    this.fetchData('/card/cardOperator', {iccid: this.$route.query.iccid}, (res) => {
      if (res.code) {
        this.operator = res.data
      }
    })
  }
}
</script>
<style scoped lang="scss">
.root{
  font-size: 0;
  height: initial;
  overflow-y: scroll;
  .box-2{
    width: 6.5rem;
    margin: .2rem auto 0;
    .box-title{
      font-size: .3rem;
      color: #000;
      text-indent: .12rem;
      letter-spacing: .06rem;
    }
    .flex{
      display: flex;
      padding: .3rem 0;
    }
    .content.noborder{
      .input-control{
        border-bottom: none;
      }
    }
    .content{
      width: 6.5rem;
      margin-top: .1rem;
      background: #fff;
      border-radius: .2rem;
      .net-check{
        height: 1rem;
        font-size: .23rem;
        margin-left: .2rem;
        width: 1.375rem;
        display: inline-block;
        text-align: center;
        vertical-align: middle;
        border:1px solid #000;
        border-radius:.1rem;
        position: relative;
       img{
         width: 1rem;
         height: .3rem;
         display: block;
         margin: .2rem auto .1rem;
       }
        .tag{
          margin: 0;
          width: .48rem;
          height: .48rem;
          position: absolute;
          right: 0;
          top: 0;
          display: none;
        }
      }
      .net-check.active{
        .tag{
          display: block;
        }
      }
      .net-check.one{
        div {
          line-height: 1rem !important;
        }
      }
      .net-check.active{
        color: #0b8ed4;
        border: 1px solid #0b8ed4;
      }
      .input-control{
        display: flex;
        width: 5.5rem;
        padding: 0 .5rem;
        border-bottom: 1px solid #ff9090;
        font-size: .25rem;
        height: .6rem;
        line-height: .6rem;
        position: relative;
        .label{
          white-space: nowrap;
        }
        input{
          border: none;
          color: #000;
          background: none;
        }
        .addon{
          width: .68rem;
          height: .3rem;
          line-height: .3rem;
          text-align: center;
          border-radius: .1rem;
          font-size: .22rem;
          color: #fff;
          position: absolute;
          right: .5rem;
          top: .15rem;
          display: inline-block;
          background: #068dff;
        }
      }
      .input-control:last-child{
        border-bottom: none;
      }
    }
  }
  .box-1{
    width: 6.5rem;
    margin: .2rem auto 0;
    background: #fff;
    display: flex;
    border-radius: .1rem;
    div{
      flex: 1.4;
      text-align: center;
      padding: .1rem;
      img{
        width: .38rem;
        height: .38rem;
        display: inline-block;
        vertical-align: middle;
      }
      span{
        margin-left: .06rem;
        font-size: .26rem;
        vertical-align: middle;
      }
    }
    :last-child{
      flex: 1;
    }
  }
  .title{
    display: flex;
    width: 4rem;
    margin: .4rem auto 0;
    background: #fff;
    border-radius: .2rem;
    padding: .2rem 0;
    line-height: 1;
    div{
      flex: 1;
      width: 2rem;
      text-align: center;
      font-size: .36rem;
      color: #000;
      border-right: 2px solid #000;
    }
    div.active{
      color: #f05964;
    }
    :last-child{
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/device.vue